import apiRoutes from '../constants/apiRoutes';
import baseApi from '../services/api';

export interface GameDataDetailsPayload {
  gameId: string;
  benchmarkingEnabled?: boolean;
  restrictedCohorts?: string[];
}

const gameDataDetails = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGameDataDetails: builder.query<any, any>({
      query: (gameId) => `${apiRoutes.games}/${gameId}/game-data-details`,
    }),
    updateGameDataDetails: builder.mutation<any, GameDataDetailsPayload>({
      query: (payload: GameDataDetailsPayload) => ({
        url: `${apiRoutes.games}/${payload.gameId}/game-data-details`,
        method: 'PUT',
        body: {
          ...('benchmarkingEnabled' in payload && {
            benchmarkingEnabled: payload.benchmarkingEnabled,
          }),
          ...('restrictedCohorts' in payload && { restrictedCohorts: payload.restrictedCohorts }),
        },
      }),
    }),
  }),
});

export const { useLazyGetGameDataDetailsQuery, useUpdateGameDataDetailsMutation } = gameDataDetails;
